import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { Ndc11ProdFirstSaleDate } from './formFields/Ndc11ProdFirstSaleDate';
import { Ndc11CodeFormField } from './formFields/Ndc11CodeFormField';

export const Ndc11ProdForm = () => {

  const afterFirstSaleValidator = (value, formValues) =>
    value < formValues.firstSaleDate ? 'Must come after First Sale Date' : null;

  const augFieldDefs = (fieldToFieldDef) => {
    delete fieldToFieldDef.ndc9ProdId;
    fieldToFieldDef.code.component = <Ndc11CodeFormField fieldDef={fieldToFieldDef.code}/>
    fieldToFieldDef.firstSaleDate.component = <Ndc11ProdFirstSaleDate fieldDef={fieldToFieldDef.firstSaleDate}/>
    fieldToFieldDef.shelfLifeExpDate.validators = [afterFirstSaleValidator];
    fieldToFieldDef.mcdTermDate.validators = [afterFirstSaleValidator];
  }

  return (
    <EntityForm augFieldDefs={augFieldDefs} />
  )
}